import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import SweepstakerInfo from './components/InfoScreen/EventsInfo';
import styled from 'styled-components';
import useEvents from 'shared/screens/Events/hooks/useEvents';
import useCheckEventsQueryParam from 'shared/screens/Events/hooks/useCheckEventsQueryParam';
import EventsCard from './components/Cards';
import QueryParamsProxy from 'shared/utils/queryParamProxy';
import Screens from 'shared/screens';
import CustomScrollBar from '../../components/CustomScrollBar';
import './scrollBarStyles.scss';
import { isMobile, isTablet } from 'react-device-detect';
import { isNotStandaloneMobilePWA, isStandalonePWA } from '../../utils/mobileSupported';

const Events = ({ navigation }) => {
  const { eventsFeatureState } = useEvents();
  const { events, texts } = eventsFeatureState;
  const { selectedCardIndex } = useCheckEventsQueryParam(events);
  const updateScrollInstance = useRef(() => null);

  useEffect(() => {
    if (events.length === 0) QueryParamsProxy.navigate(navigation, Screens.Home);
  }, []);

  let eventsAssets = useSelector(state => state.assetsPackage.assets.EVENTS_FEATURE);

  return eventsAssets ? (
    <Container>
      <SweepstakerInfo eventsAssets={eventsAssets} eventsTexts={texts} />
      <Background src={eventsAssets.EVENTS_BACKGROUND} />
      <EventsContainer>
        <CustomScrollBar
          updateScrollInstance={updateScrollInstance}
          isDraggableX={true}
          hideScrollbars={true}
          customHeight="0"
          showVertical={false}
          showHorizontal={true}
          customStyle={styles.CustomScrollBarContainerStyle}
          customHorizontalTrackStyle={styles.customHorizontalTrackStyle}
          customClassNames="custom-scrollbar-events"
        >
          {events?.map((item, index) => (
            <EventsCard
              key={item.eventId ?? index}
              defaultOpen={selectedCardIndex === index}
              object={item}
              eventsAssets={eventsAssets}
              texts={texts}
              updateScrollInstance={updateScrollInstance}
              navigation={navigation}
            />
          ))}
        </CustomScrollBar>
      </EventsContainer>
    </Container>
  ) : (
    <></>
  );
};

export default Events;

const Container = styled.div`
  height: 100%;
  align-items: center;
  width: 100vw;
`;

const Background = styled.img`
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: -1;
  width: 100%;
  height: 100%;
`;

const EventsContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  height: 99%;
  overflow: hidden;
  white-space: nowrap;
  &:first-of-type {
    .sc-liaBrn {
      padding-right: 25vh;
      @media only screen and (min-height: 950px) and (max-height: 1100px) {
        gap: 15%;
      }

      @media only screen and (max-height: 800px) {
        padding-right: 30vh;
      }
    }
  }
`;

const styles = {
  customHorizontalTrackStyle: {
    position: 'fixed !important',
    bottom: '10px !important',
  },
  CustomScrollBarContainerStyle: {
    flexDirection: 'row',
    gap: '7%',
    display: 'flex',
    paddingTop: (isTablet && isStandalonePWA) ? '13vh' : (isTablet && isNotStandaloneMobilePWA) ? '12vh' : isStandalonePWA ? '15vh' : (!isStandalonePWA && isMobile) ? '10vh' : '12vh',
    paddingLeft: '3rem',
    marginLeft: '5rem',
  },
};

